import React, { useState } from "react";
import RecentChatList from "./RecentChatList";
import { Popover } from "antd/lib";
import { useSelector } from "react-redux";

function Index() {
  // Chat Service Class
  const fgChat = useSelector(({ fgChat }: any) => fgChat);
  const [showMenu, setShowMenu] = useState(false);

  return (
    <li className="gx-msg">
      <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomLeft"
        content={
          <div>
            <RecentChatList setShowMenu={setShowMenu} />{" "}
          </div>
        }
        trigger="click"
        visible={showMenu}
        onVisibleChange={(val) => setShowMenu(val)}
      >
        <span className="gx-pointer gx-status-pos gx-d-block">
          <i className="icon icon-chat-new" />
          {fgChat.userRoomsWithNewMessage.length > 0 && (
            <span className="gx-status gx-status-rtl gx-small gx-orange" />
          )}
        </span>
      </Popover>
    </li>
  );
}

export default Index;
